import { StepTimelineComponent } from './step-timeline/step-timeline.component';
import { InputModelsComponent } from './input-models/input-models.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from 'src/app/shared/shared.module';
import { AsideComponent } from './aside/aside.component';
import { FooterComponent } from './footer/footer.component';
import { ModelModalTxtComponent } from './dialogs/model-modal-txt/model-modal-txt.component';
import { ModelModalContactComponent } from './dialogs/model-modal-contact/model-modal-contact.component';
import { ModalInstructionsQrCodeComponent } from './dialogs/modal-instructions-qr-code/modal-instructions-qr-code.component';
import { ModelModalOneButtonComponent } from './dialogs/model-modal-one-button/model-modal-one-button.component';
import { TopBarComponent } from './top-bar/top-bar.component';
import { AlertBarComponent } from './alert-bar/alert-bar.component';
import { ModelModalTwoButtonComponent } from './dialogs/model-modal-two-button/model-modal-two-button.component';
import { ModalHelpPensionComponent } from './dialogs/modal-help-pension/modal-help-pension.component';
import { ModalHelpDelinquentComponent } from './dialogs/modal-help-delinquent/modal-help-delinquent.component';
import { ModalTutorialArmyComponent } from './dialogs/modal-tutorial-army/modal-tutorial-army.component';
import { LoadingComponent } from './loading/loading.component';
import { AlertBarInvalidComponent } from './alert-bar-invalid/alert-bar-invalid.component';
import { TutorialComponent } from './tutorial/tutorial.component';
import { SwiperModule } from 'swiper/angular';
import { HintFieldComponent } from './dockingParts/hint-field/hint-field.component';
import { RouterLink, RouterModule } from '@angular/router';
import { ModalIdDocumentComponent } from './dialogs/modal-id-document/modal-id-document.component';
import { ModalContractDocumentComponent } from './dialogs/modal-contract-document/modal-contract-document.component';
import { ModelModalLinkOneButtonComponent } from './dialogs/model-modal-link-one-button/model-modal-link-one-button.component';
import { ModalAuthDebitComponent } from './dialogs/modal-auth-debit/modal-auth-debit.component';
import { ModalRedirectBBComponent } from './dialogs/modal-redirect-bb/modal-redirect-bb.component';
import { ModalPreferencesComponent } from './dialogs/modal-preferences/modal-preferences.component';
import { ModalCircularComponent } from './dialogs/modal-circular/modal-circular.component';
import { ModalPrivacyPolicyComponent } from './dialogs/modal-privacy-policy/modal-privacy-policy.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ModalPepComponent } from './dialogs/modal-pep/modal-pep.component';
import { SessionService } from '../services/session/session.service';
import { ModalLocationComponent } from './dialogs/modal-location/modal-location.component';
import { PolicityService } from '../services/policity/policity.service';
import { SystemDevelopmentBarComponent } from './system-development-bar/system-development-bar.component';
import { ModalSystemsComponent } from './modal-systems/modal-systems.component';
import { CurrencyEditorComponent } from './currency-editor/currency-editor.component';
import { ModalContractComponent } from './dialogs/modal-contract/modal-contract.component';
import { BtnWhatsappComponent } from './btn-whatsapp/btn-whatsapp.component';
import { BtnSacComponent } from './btn-sac/btn-sac.component';
import { BtnWhatsappBorderComponent } from './btn-whatsapp-border/btn-whatsapp-border.component';
import { SacContactLinkComponent } from './sac-contact-link/sac-contact-link.component';
import { ModelModalResendPasswordComponent } from './dialogs/model-modal-resend-password/model-modal-resend-password.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    SwiperModule,
    RouterModule,
    PdfViewerModule,
  ],
  exports: [
    AsideComponent,
    FooterComponent,
    AlertBarComponent,
    AlertBarInvalidComponent,
    TopBarComponent,
    StepTimelineComponent,
    InputModelsComponent,
    ModelModalTxtComponent,
    ModelModalContactComponent,
    ModalInstructionsQrCodeComponent,
    ModelModalOneButtonComponent,
    ModalHelpPensionComponent,
    ModalHelpDelinquentComponent,
    ModalTutorialArmyComponent,
    TutorialComponent,
    BtnWhatsappComponent,
    BtnWhatsappBorderComponent,
    BtnSacComponent,
    SacContactLinkComponent,
    LoadingComponent,
    HintFieldComponent,
    SystemDevelopmentBarComponent,
    ModalSystemsComponent,
    ModelModalResendPasswordComponent,
    PdfViewerModule,
  ],

  declarations: [
    AsideComponent,
    FooterComponent,

    AlertBarComponent,
    AlertBarInvalidComponent,

    TopBarComponent,
    StepTimelineComponent,
    InputModelsComponent,

    ModelModalTxtComponent,
    ModelModalContactComponent,
    ModalInstructionsQrCodeComponent,
    ModelModalOneButtonComponent,
    ModalHelpPensionComponent,
    ModalHelpDelinquentComponent,
    ModalTutorialArmyComponent,
    ModalPrivacyPolicyComponent,
    AlertBarComponent,
    ModelModalTwoButtonComponent,
    LoadingComponent,
    AlertBarInvalidComponent,
    TutorialComponent,
    HintFieldComponent,
    ModalIdDocumentComponent,
    ModalContractDocumentComponent,
    ModelModalLinkOneButtonComponent,
    ModalAuthDebitComponent,
    ModalRedirectBBComponent,
    ModalPreferencesComponent,
    ModalCircularComponent,
    ModalPepComponent,
    ModalLocationComponent,
    SystemDevelopmentBarComponent,
    ModalSystemsComponent,
    CurrencyEditorComponent,
    ModalContractComponent,
    BtnWhatsappComponent,
    BtnSacComponent,
    BtnWhatsappBorderComponent,
    SacContactLinkComponent,
    ModelModalResendPasswordComponent,
  ],

  providers: [SessionService, PolicityService],
})
export class ComponentsModule {}
